<template>
  <Layout class="publisher" style="background-color:#f5f5f5; height:calc(100vh - 64px);">
    <Content v-if="isReady">
      <Window
        title="Slide Deck"
        v-if="visibles['Slide Deck'].show"
        @visibilityToggle="hideWindow('Slide Deck')"
        @showTabHandler="showWindow('Slide Deck')"
        top="32px"
        left="32px"
        ww="67%"
        :wh="win.innerHeight - 124 + 'px'"
        :zindex="visibles['Slide Deck'].index"
      >
        <SlideManager v-if="$data.isReady"></SlideManager>
      </Window>
      <Window
        title="Questions"
        v-if="visibles['Questions'].show"
        @visibilityToggle="hideWindow('Questions')"
        @showTabHandler="showWindow('Questions')"
        top="32px"
        left="32px"
        ww="1024px"
        wh="80%"
        :zindex="visibles['Questions'].index"
      >
        <PublisherQuestions />
      </Window>
      <Window
        title="Team Chat"
        v-if="visibles['Team Chat'].show"
        @visibilityToggle="hideWindow('Team Chat')"
        @showTabHandler="showWindow('Team Chat')"
        top="40%"
        left="70%"
        ww="27%"
        wh="50%"
        :zindex="visibles['Team Chat'].index"
      >
        <TeamChat />
      </Window>
      <Window
        title="Participants"
        v-if="visibles['Participants'].show"
        @visibilityToggle="hideWindow('Participants')"
        @showTabHandler="showWindow('Participants')"
        top="32px"
        left="32px"
        ww="1024px"
        wh="80%"
        :zindex="visibles['Participants'].index"
      >
        <ParticipantList style="margin-top:-32px; width:100%;" />
      </Window>
      <Window
        title="Q&A Moderation"
        v-if="visibles['Q&A Moderation'].show"
        @visibilityToggle="hideWindow('Q&A Moderation')"
        @showTabHandler="showWindow('Q&A Moderation')"
        top="32px"
        left="32px"
        ww="1024px"
        wh="80%"
        :zindex="visibles['Q&A Moderation'].index"
      >
        <QnaManager class="qna-manager" style="margin-top:32px; width:100%;" />
      </Window>
    </Content>
    <PublisherBottomNav @visibilityToggle="showWindow" />
  </Layout>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import SlideManager from "./SlideManager.vue";
import WebRTCVideo from "./WebRTCVideo.vue";
import PublisherBottomNav from "./PublisherBottomNav.vue";
import ConnectionSelection from "./ConnectionSelection.vue";
import TeamChat from "./TeamChat.vue";
import PublisherQuestions from "./PublisherQuestions.vue";
import Window from "./Window.vue";
import QnaManager from "@/components/webcast/QnaManager.vue";
import ParticipantList from "./ParticipantList.vue";

export default {
  components: {
    SlideManager,
    WebRTCVideo,
    PublisherBottomNav,
    PublisherQuestions,
    ConnectionSelection,
    TeamChat,
    QnaManager,
    ParticipantList,
    Window
  },
  data() {
    return {
      isReady: false,
      isOpen: true,
      resizable: true,
      slidesVisible: false,
      isCollapsed: true,
      win: window,
      visibles: {
        "Slide Deck": { show: true, index: 0 },
        "Team Chat": { show: true, index: 0 },
        Questions: { show: false, index: 0 },
        "Q&A Moderation": { show: false, index: 0 },
        Participants: { show: false, index: 0 }
      }
    };
  },

  computed: {
    ...mapGetters("webcast", {
      webcast: "getCopy"
    }),
    menuitemClasses: function() {
      return ["menu-item", this.isCollapsed ? "collapsed-menu" : ""];
    },
    widthTwoOfThree() {
      console.log(window.innerWidth);
      return (window.innerWidth / 3) * 2 - 20;
    },
    widthOneOfThree() {
      console.log(window.innerWidth);
      return window.innerWidth / 3 - 40;
    }
  },
  methods: {
    ...mapActions("webcast", {
      getWebcast: "get"
    }),
    showSlides() {
      this.slidesVisible = true;
    },
    hideWindow(winName) {
      this.visibles[winName].show = false;
    },
    showWindow(winName) {
      for (const win in this.visibles) {
        this.visibles[win].index = 99;
        // this.visibles[win].show = false
      }
      this.visibles[winName].show = true;
      this.visibles[winName].index = 999;
    }
  },
  created() {
    this.getWebcast(this.$router.currentRoute.params.id).then(wc => {
      this.$store.commit("webcast/setCurrent", wc._id);
      this.$data.isReady = true;
    });
  }
};
</script>
<style lang="scss">
.publisher {
  .layout-con {
    height: 100%;
    width: 100%;
  }
  .ivu-menu-vertical .ivu-menu-item {
    padding: 18px 18px !important;
  }
  .menu-item span {
    display: inline-block;
    overflow: hidden;
    width: 130px;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: bottom;
    transition: width 0.1s ease 0.1s;
  }
  .menu-item i {
    transform: translateX(0px);
    transition: font-size 0.1s ease, transform 0.1s ease;
    vertical-align: middle;
    font-size: 16px;
  }
  .collapsed-menu span {
    width: 0px;
    transition: width 0.2s ease;
  }
  .collapsed-menu i {
    transform: translateX(5px);
    transition: font-size 0.1s ease 0.1s, transform 0.1s ease 0.1s;
    vertical-align: middle;
    font-size: 18px;
  }
}
</style>
